import { ContentStateInterface } from '../../../../../../@types/types'

export const rentDurationsToApi = (insertionData: ContentStateInterface) => ({
  LONG_TERM: insertionData.rentDurations?.longTerm,
  WEEKLY: insertionData.rentDurations?.weekly,
  MONTHLY: insertionData.rentDurations?.monthly,
  YEARLY: insertionData.rentDurations?.yearly,
})
